export default {"src":"/_next/static/media/starFull.11099566.svg","height":20,"width":21};